exports = module.exports = require("./../../../../react-scripts/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h2{margin-bottom:16px}.filter-input{border:1px solid #ddd;border-radius:4px;padding:8px;width:150px;float:right;transition:width .25s}.filter-input:focus{width:250px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/react-scripts/~/css-loader!/opt/atlassian/pipelines/agent/build/~/less-loader!./src/css/component-index.less
// module id = 580
// module chunks = 0